import {rem, standardFont} from '-/styles/utils';

export const mainButton = (color, bgColor) => {
    return {
        display: 'inline-block',
        width: '100%',
        margin: `0 auto ${rem(40)}`,
        padding: `${rem(16)} 0`,
        borderRadius: 56,
        fontWeight: 'bold',
        textAlign: 'center',
        textDecoration: 'none',
        textTransform: 'uppercase',
        letterSpacing: 1.2,
        color,
        backgroundColor: bgColor,
        transition: 'background-color 0.3s ease-in-out',
        boxShadow: '0 5px 4px rgba(0, 0, 0, 0.19)',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        WebkitTouchCallout: 'none',
        border: 'none',
        '&:link, &:visited': {
            color
        },
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline'
        }
    };
};

export const standardButton = (color, bgColor) => {
    return {
        ...standardFont(),
        color,
        backgroundColor: bgColor,
        minHeight: 47,
        padding: `0 ${rem(18)}`,
        border: 'none',
        borderRadius: rem(5),
        marginTop: 5,
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline'
        }
    };
};
